<template>
    <div class="tourn-error">
        <span>{{ error.message }}</span>
        <a v-if="reasonable" class="collapsed" data-toggle="collapse" :href="'#'+collapsible" role="button"
           aria-expanded="false"
           aria-controls="collapsible">
            <span><i class="icon ion icon-fw ml-3 mr-1"></i>more</span>
        </a>
        <div class="collapse" :id="collapsible">
            <json-to-html v-if="modified" :json="modified" :inheritClassName="false" rootTagName="section"/>
        </div>
    </div>
</template>

<script>
  import JsonToHtml from 'vue-json-to-html';
  import uid from '@/js/mixins/uid';

  export default {
    name: 'TournError',
    props: {
      error: Object,
    },
    components: {
      JsonToHtml,
    },
    mixins: [uid],
    computed: {
      modified() {
        let traces = this.error.trace || [];
        traces = traces.map(trace => {
          return {
            method: {
              class: trace.class || '',
              function: trace.function || '',
            },
            context: {
              file: trace.file || '',
              line: trace.line || '',
            },
          };
        });
        return {
          exception: {
            title: this.error.exception,
            message: this.error.message,
          },
          trace: traces,
        };
      },
      reasonable() {
        return this.modified.trace.length > 0;
      },
      collapsible() {
        return `error-collapsible-${this.uid}`;
      },
    },
  };
</script>

<style lang="scss">
    .tourn-error {
        [data-toggle="collapse"] {
            .ion {
                &:before {
                    content: "\f280";
                }
            }

            &.collapsed {
                .ion {
                    &:before {
                        content: "\F284";
                    }
                }
            }
        }

        section {
            background-color: #ded8d8;

            .exception {
                color: white;
                box-sizing: border-box;
                background-color: #2a2a2a;
                padding: 30px 19px;;
                max-height: 180px;
                overflow: hidden;
                transition: 0.5s;

                .title {
                    margin: 0;
                    color: #bebebe;
                    font-size: 14px;
                }

                .message {
                    font-size: 20px;
                    word-wrap: break-word;
                    margin: 4px 0 0 0;
                    color: white;
                }
            }

            .trace {
                margin: 5px;

                & > div {
                    padding: 14px;
                    cursor: pointer;
                    transition: all 0.1s ease;
                    background: #eeeeee;

                    &:not(:last-child) {
                        border-bottom: 1px solid rgba(0, 0, 0, .05);
                    }

                    &:hover {
                        background: #BEE9EA;
                    }
                }

                .class, .function {
                    font-size: 14px;
                }

                .function:before {
                    content: "@";
                }

                .method {
                    color: #000000;
                }

                .method, .context {
                    display: flex;
                }

                .file {
                    color: #a29d9d;
                    font-size: 12px;
                }

                .line {
                    font-size: 12px;
                    font-weight: bold;

                    &:before:not(:empty) {
                        content: ":";
                    }
                }
            }
        }
    }
</style>
